/**
 * PATH: packages/ui/src/components/mobile-dock/mobileDockItems.ts
 * FILE_ID: MASTER-SHELL-MOBILEDOCK-ITEMS-001
 * PURPOSE: Dock item types + active-route matcher for MobileDock.
 * WHY: Keep index.tsx under the 500-line ceiling.
 */
import type { ComponentType } from 'react'

export type DockItemKind = 'nav' | 'hub' | 'utility'
export type DockItemStatus = 'production' | 'development' | 'planned'

export interface DockItem {
  id: string
  label: string
  icon: ComponentType<{ className?: string }> | undefined
  href: string
  kind: DockItemKind
  /** Only set for `kind === 'hub'`. */
  status?: DockItemStatus
}

export function isExternalHref(href: string): boolean {
  return /^https?:\/\//i.test(href)
}

export function isDockItemActive(currentPath: string, item: DockItem): boolean {
  if (item.kind === 'hub' && isExternalHref(item.href)) return false
  const href = item.href || ''
  if (!href) return false
  if (currentPath === href) return true
  if (href !== '/' && currentPath.startsWith(`${href}/`)) return true
  if (item.id === 'dashboard' && (currentPath === '/' || currentPath.startsWith('/dashboard'))) {
    return true
  }
  return false
}
